import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { SplashScreen } from '@capacitor/splash-screen';
import posthog from 'posthog-js';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { enableProdMode } from '@angular/core';

if(environment.POSTHOG_ENABLED_TRACKING){ 
posthog.init(
  environment.POSTHOG_API_KEY,
  {
    api_host: environment.POSTHOG_API_HOST,
    person_profiles: 'identified_only'
  }
)

  posthog.register({
    default_date: environment.POSTHOG_API_DEFAULTS
  });
}

defineCustomElements(window);
if (environment.PRODUCTION) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    SplashScreen.hide();
  }).catch(err => console.log(err));


const isProduction = environment.PRODUCTION;

if (isProduction) {
  const disabledMethods: (keyof Console)[] = ['log', 'warn', 'error', 'debug', 'info'];

  disabledMethods.forEach((method) => {
    (console[method] as (...args: any[]) => void) = (..._args: any[]) => { };
  });

} else {
  const formatArgs = (args: any[]) =>
    args.map(arg =>
      typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg)
    ).join(' ');

  const originalLog = console.log;
  console.log = function (...args: any[]) {
    try {
    } catch (e) {
    }
    originalLog.apply(console, args);
  };

  const originalError = console.error;
  console.error = function (...args: any[]) {
    try {
    } catch (e) {
    }
    originalError.apply(console, args);
  };
}
